import locationImg from '../assets/images/location.jpg'

export const faqAnswers = [
    {
        title: 'How to find us?',
        description: `
        <p class='mb-[20px]'>
            Our clinic is located in the heart of Preston. With many ways to reach us, we've provided directions from a few locations that are close by:
        </p>
        <ul class='mb-[20px]'>
            <li>Directions from Fishergate Shopping Centre Car Park (<a target='_blank' rel="noreferrer" class='text-[#846bb9] hover:text-[#6bb2b9]' href="https://www.google.co.uk/maps/dir/fishergate+shopping+centre/Kenworthy+Chiropractic,+9+Theatre+St,+Preston+PR1+8BQ/@53.7565207,-2.7076063,17z/data=!3m1!4b1!4m14!4m13!1m5!1m1!1s0x487b727bb8913e61:0xb5c06144a548aa9b!2m2!1d-2.7053787!2d53.7556188!1m5!1m1!1s0x487b727ba0d2f17d:0x2c9877882140f163!2m2!1d-2.7043615!2d53.7568915!3e2">Google Maps</a> | <a target='_blank' rel="noreferrer" class='text-[#846bb9] hover:text-[#6bb2b9]' href="https://maps.apple.com/?daddr=Kenworthy%20Chiropractic,%209%20Theatre%20St,%20Town%20Centre,%20Preston,%20PR1%208BQ,%20England&amp;dirflg=w&amp;saddr=Parking,%20Fishergate,%20Preston,%20PR1%208HJ,%20England">Apple Maps</a>)</li>
            <li>Directions from St Georges Car Park (<a target='_blank' rel="noreferrer" class='text-[#846bb9] hover:text-[#6bb2b9]' href="https://www.google.co.uk/maps/dir/St+Georges+Car+Park,+Chapel+Walks,+Preston+PR1+2AY/Kenworthy+Chiropractic,+9+Theatre+St,+Preston+PR1+8BQ/@53.7575625,-2.7058897,17z/data=!3m1!4b1!4m14!4m13!1m5!1m1!1s0x487b7362830f1645:0x47055ddbbbfc9182!2m2!1d-2.7024658!2d53.7582444!1m5!1m1!1s0x487b727ba0d2f17d:0x2c9877882140f163!2m2!1d-2.7043615!2d53.7568915!3e2">Google Maps</a> | <a target='_blank' rel="noreferrer" class='text-[#846bb9] hover:text-[#6bb2b9]' href="https://maps.apple.com/?daddr=Kenworthy%20Chiropractic,%209%20Theatre%20St,%20Town%20Centre,%20Preston,%20PR1%208BQ,%20England&amp;dirflg=w&amp;saddr=St.%20George's%20Shopping%20Centre,%20St%20Georges%20Church,%2026%20George's%20Road,%20Town%20Centre,%20Preston,%20PR1%202NP,%20England">Apple Maps</a> )</li>
            <li>Directions from Preston Train Station (<a target='_blank' rel="noreferrer" class='text-[#846bb9] hover:text-[#6bb2b9]' href="https://www.google.co.uk/maps/dir/Preston,+Fishergate,+Preston/Kenworthy+Chiropractic,+9+Theatre+St,+Preston+PR1+8BQ/@53.7565887,-2.7076063,17z/data=!3m1!4b1!4m14!4m13!1m5!1m1!1s0x487b727966a0fafb:0x9e0ae04a0563906!2m2!1d-2.7065186!2d53.7555764!1m5!1m1!1s0x487b727ba0d2f17d:0x2c9877882140f163!2m2!1d-2.7043615!2d53.7568915!3e2">Google Maps</a> | <a target='_blank' rel="noreferrer" class='text-[#846bb9] hover:text-[#6bb2b9]' href="https://maps.apple.com/?daddr=Kenworthy%20Chiropractic,%209%20Theatre%20St,%20Town%20Centre,%20Preston,%20PR1%208BQ,%20England&amp;dirflg=w&amp;saddr=Preston%20Train%20Station,%20Preston,%20England">Apple Maps</a>)</li>
            <li>Clinic Location (<a target='_blank' rel="noreferrer" class='text-[#846bb9] hover:text-[#6bb2b9]' href="https://www.google.co.uk/maps/place/Kenworthy+Chiropractic/@53.7824714,-2.7034448,12z/data=!4m5!3m4!1s0x487b727ba0d2f17d:0x2c9877882140f163!8m2!3d53.7568915!4d-2.7043615">Google Maps</a> | <a target='_blank' rel="noreferrer" class='text-[#846bb9] hover:text-[#6bb2b9]' href="https://maps.apple.com/?address=9%20Theatre%20St,%20Town%20Centre,%20Preston,%20PR1%208BQ,%20England&amp;auid=4115784595818207025&amp;ll=53.757078,-2.704372&amp;lsp=9902&amp;q=Kenworthy%20Chiropractic&amp;_ext=CjIKBQgEEOEBCgQIBRADCgQIBhByCgQIChAACgQIUhADCgQIVRAQCgQIWRADCgUIpAEQARImKV+Yp79U4EpAMcKe8f0csgXAOd1tzRt74UpAQTzR6a/+kgXAUAQ%3D">Apple Maps</a> )</li>
        </ul>`,
        image: locationImg,
    },
    {
        title: 'What is Chiropractic?',
        description: `
        <p class='mb-4'>
            Chiropractic is a gentle, precise and effective method of adjusting bones and joints to improve skeletal alignment. This method of treatment allows the nervous system to work more efficiently, helps to relieve pain and improve mobility. It’s also completely drug free.
        </p> 
        <p class='mb-4'>
        Chiropractic is a regulated primary healthcare profession. Chiropractors are trained to diagnose, treat, manage and prevent disorders of the musculoskeletal system (bones, joints, and muscles), as well as the effects these disorders can have on the nervous system and general health. When they assess patients, they take their entire physical, emotional and social wellbeing into account.
        </p>
        <p class='mb-4'>
        Chiropractors use a range of techniques to reduce pain, improve function and increase mobility, including hands-on manipulation of the spine. The movement of the bones in the spine generates negative pressure causing bubbles made of oxygen and nitrogen gas and carbon dioxide in the joint to pop which is the sound you may hear (a popping or ‘cracking’ noise).
        </p>
        <p class='mb-4'>
        As well as manual treatment, chiropractors are able to offer a package of care, which includes advice on self-help, therapeutic exercises and lifestyle changes.
        </p>
        <p class='mb-4'>
        Chiropractic treatment mainly involves safe, often gentle, specific spinal manipulation to free joints in the spine or other areas of the body that are not moving properly. Apart from manipulation, chiropractors may use a variety of techniques including ice, heat, exercise and advice about posture and lifestyle.
        </p>
`
    },
    {
        title: 'Meet the Team',
        link: true,
        linkTo: 'meet-the-team'
    },
    {
        title: 'Is chiropractic regulated?',
        description: `
        <p class='mb-[20px]'>
            Chiropractic is regulated by the General Chiropractic Council. Chiropractors are only permitted to practice if they are registered with the GCC.
        </p> `
    },
    {
        title: 'What can I expect at my first treatment?',
        description: `
        <p class='mb-[20px]'>
            A full medical history is taken by the Chiropractor to ensure that Chiropractic is a safe and appropriate treatment for the presenting symptoms. Patients will be asked about past and current illnesses, medications, previous accidents or surgery and a description of the current condition.
        </p> 
        <p class='mb-[20px]'>
            Once a full history has been recorded you will undergo a series of basic health checks followed by a series of neurological; orthopaedic and range of motion assessments. These tests help to determine the reason for the pain and to identify any positions that trigger the pain.
        </p> 
        <p class='mb-[20px]'>
            In most instances you will then receive a treatment and will be advised upon the optimization of your chiropractic care.
        </p> 
        <p class='mb-[20px]'>
            First appointments take longer than subsequent appointments and can last anywhere between 40 – 90 minutes.
        </p> 
`
    },
    {
        title: 'What can I expect from a follow up treatment?',
        description: `
        <p class='mb-[20px]'>
            Subsequent treatments will be shorter, usually lasting between 20-40 minutes dependent upon the condition presented. Your chiropractor will ask you for feedback regarding your treatment and will outline any changes she has observed since your last treatment. Your treatment plan will then be modified accordingly.
        </p> 
`
    },
    {
        title: 'How many treatments am I likely to need?',
        description: `
        <p class='mb-2'>
            Chiropractic care focuses on the cause of the problem. By supporting the body's natural processes (and innate intelligence), a series of manual adjustments to realign the body achieves effective outcomes.
        </p>

        <p class='mb-2'>
        How many visits you need will be determined by several factors:
        </p>

        <ol class='mb-2 pl-5 list-disc	'>
            <li>What the cause it</li>
            <li>How long you have been experiencing symptoms</li>
            <li>If you have any other conditions</li>
            <li>Your age</li>
            <li>What you want to achieve through your care</li>
            <li>Your lifestyle i.e. levels of stress, physical exertion/activeness</li>
        </ol>
        <p>
        <p class='mb-4'>
            Your chiropractor will discuss a treatment plan that’s right for you at your first assessment. However, at Kenworthy Chiropractic we always aim to resolve your issue with the minimum number of treatments possible.

        </p> 
`
    },
    {
        title: 'What should I wear?',
        description: `
    <p class='mb-[20px]'>Light, loose fitting clothing. Most treatments do not require the patient to undress,
        but
        it would be prudent to wear discreet/large underwear, or bring along a pair of
        shorts.</p> `
    },
    {
        title: 'Who designed your website?',
        description: `
            <p class='mb-[20px]'>The website was created by Codie Stephens, please email
                <a target='_blank' rel="noreferrer" class='text-[#846bb9] hover:text-[#6bb2b9] transition-all duration-200 ease-in' href="mailto:cstephens90@me.com">hello@codie.uk</a> for any
                enquiries.
            </p> 
        `
    },
    {
        title: 'Audio Credits',
        description: `
            <p class='mb-[20px]'>1. The Cat and the Camel, 4. The Supine Piriformis Stretch and 7. The Short Adductor
                <b class='font-bold' r> "Carefree" Kevin MacLeod (incompetech.com)
                <b class='font-bold' r> Licensed under Creative Commons: By Attribution 3.0 License
                http://creativecommons.org/licenses/by/3.0/
            </p> 
            <p class='mb-[20px]'>2. The Child Pose and 6. The Long Adductor
                <b class='font-bold' r> "Fretless" Kevin MacLeod (incompetech.com)
                <b class='font-bold' r> Licensed under Creative Commons: By Attribution 3.0 License
                http://creativecommons.org/licenses/by/3.0/
            </p> 
            <p class='mb-[20px]'>3. The Bridge and 8. The Pec Stretch
                <b class='font-bold' r> "Cheery Monday" Kevin MacLeod (incompetech.com)
                <b class='font-bold' r> Licensed under Creative Commons: By Attribution 3.0 License
                http://creativecommons.org/licenses/by/3.0/
            </p> 
            <p class='mb-[20px]'>5. The Outer Hip Piriformis Stretch
                <b class='font-bold' r> "On My Way" Kevin MacLeod (incompetech.com)
                <b class='font-bold' r> Licensed under Creative Commons: By Attribution 3.0 License
                http://creativecommons.org/licenses/by/3.0/
            </p> 
    `
    },
    {
        title: 'Privacy Policy',
        description: `
            <p class='mb-[20px]'>
                Kenworthy Chiropractic is committed to safeguarding the privacy of our patients in full compliance of the Data Protection Act 2018 (this includes the General Data Protection Regulations (GDPR):
            </p> 
            <p class='mb-[20px]'>
                Your personal information is stored and processed for the following three reasons under the Data Protection Act 2018.
            </p> 
            <ul class='mb-[20px]'>
                <li>
                    The patient’s request for treatment either in person, or via our Cliniko online booking system and Kenworthy Chiropractic’s agreement to provide that treatment constitutes a “Contract”. Kenworthy Chiropractic needs to collect personal information about your health in order to ensure that the treatment is appropriate and to provide you with the best possible treatment.
                </li>
                <li>
                    Kenworthy Chiropractic has a “Legitimate Interest” in collecting that information because without it we could not perform our duties under the Contract effectively and safely.
                </li>
                <li>
                    Kenworthy Chiropractic also has a “Legitimate Interest” in being able to contact you via email, SMS and telephone to confirm your appointments with us, send out appointment reminders and to update you on matters related to your health care, or relevant clinic information that might affect you.
                </li>
            </ul>
            <b class='font-bold'>Medical History</b>
            <ul class='mb-[20px]'>
                <li>
                    All patients must consent to a full disclosure of all their current symptoms and medical history in order for the chiropractor to treat them safely. This information is kept with their personal information in a lockable filing cabinet.
                </li>
                <li>
                    The patient’s doctor is not contacted without their consent (there is a consent box that must be ticked on their Initial Assessment Form. The patient’s response is added to their online information stored by Cliniko). If the chiropractor needs to speak to another medical profession and the consent box hasn’t been ticked she will seek verbal consent from the patient.
                </li>
            </ul>
            <b class='font-bold' >Amending/Updating Patient Information </b>
            <p class='mb-[20px]'>
            A patient may request that Kenworthy Chiropractic make changes to their information,
                as it is stored either in Cliniko, or on their initial registration form. GDPR
                defines this as the&nbsp;Right to Rectification. A patient can also change their details
                online via Cliniko. If you believe the information we have for you is inaccurate,
                you can ask us to correct or remove it (subject to the legal requirements mentioned
                above) by writing to us at Kenworthy Chiropractic, 9 Theatre Street, Preston, PR1
                8BQ, or emailing us at <a target='_blank' rel="noreferrer" class='text-[#846bb9] hover:text-[#6bb2b9]' href="mailto:enquiries@kenworthychiropractic.com">enquiries@kenworthychiropractic.com</a>
            </p> 
            <p class='mb-[20px]'>We have a Legal Obligation under The Chiropractors Act 1994 to retain your records
                for eight years after your most recent appointment (or age 25 if this is longer).
                After this period you can ask us to delete your records if you wish. If not we will
                retain your records indefinitely in order that we can provide you with the best
                possible care should you need to see us at some future date.</p> 
            <p class='mb-[20px]'>Confidential patient information is only available to staff at this clinic with a
                direct and appropriate need for access. These include:</p> 
            <ul class='mb-[20px]'>
                <li>The Practitioner/s so that they can provide you with the appropriate and
                    necessary treatment.</li>
                <li>The Clinic Manager/reception staff so that they can transcribe and update
                    patient files, coordinate appointments and reminders, collate financial
                    information and liaise with the practitioner.</li>
            </ul>
            <b class='font-bold' >Opting Out</b>
            <p class='mb-[20px]'>Patients may amend their personal data online via the Cliniko Online Booking System.
                Patients also have the option to opt in, or out of SMS messages and emails for
                marketing purposes (although Kenworthy Chiropractic doesn’t use any SMS, or email
                based marketing). If patients do not have access to a computer they are welcome to
                contact the clinic directly to arrange for such changes to be made.</p> 
            <p class='mb-[20px]'>If you are not satisfied with our response you have the right to raise the matter
                with the&nbsp;Information Commissioner’s Office.</p> 
            <b class='font-bold' >Cookie Policy </b>
            <p class='mb-[20px]'>Kenworthy Chiropractic does not use any 3rd party cookies for marketing purposes.
                However, some 1st party cookies are used via Google Analytics to allow us to monitor
                our website performance and statistics. i.e. First party cookies are cookies that
                are set by the site itself and can only be read by this site. They are commonly used
                for the functionality of the site. This doesn't imply that these cookies are allowed
                by EU law.&nbsp;&nbsp;</p> 
            <b class='font-bold' >Cliniko Online Booking Service</b>
            <p class='mb-[20px]'>
                Cliniko is hosted in state of the art datacenter facilities. Physical access is
                controlled both at the perimeter and at building ingress points by professional
                security staff utilising video surveillance, intrusion detection systems, and other
                electronic means.</p> 
            <p class='mb-[20px]'>For more information please follow this link: <a target='_blank' rel="noreferrer" class='text-[#846bb9] hover:text-[#6bb2b9]' href="https://www.cliniko.com/security">https://www.cliniko.com/security</a></p> 
            <b class='font-bold' >Website/Clinic Computers</b>
            <p class='mb-[20px]'>Access from www.kenworthy.chiorpractic.com is fully protected (SSL certificate with
                GoDaddy) and we pay an additional subscription for a secure email facility.</p> 
            <p class='mb-[20px]'>Kenworthy Chiropractic also uses the Avast security system to mask their location
                online and encrypt digital data leaving the clinic.</p> 
            <b class='font-bold' >Financial Transactions</b>
            <p class='mb-[20px]'>A record of Receipts and Payments for Services and Products supplied is maintained
                via our Cliniko software.</p> 
            <p class='mb-[20px]'>Merchant copies of each transaction are retained for accounting purposes. The credit
                card number is not fully visible i.e. 4 of the digits are obscured to prevent
                fraudulent copying and usage.</p> 
            <p class='mb-[20px]'>We do not collect any Credit or Debit Card information as this is processed via
                Payment Sense’s secure payment service. However, in accordance with Finance Industry
                Practice we are required to keep a copy of the paper Card Receipt (which contains
                part of your Card number) for two years from the date of the transaction after which
                it is securely destroyed ( a reminder has been placed on iCalendar as a reminder).
            </p> 
            <b class='font-bold' >Other disclosures</b>
            <ol>
                <li> We may disclose information about you:</li>
                <ol type="a">
                    <li>to the extent that we are required to do so by law;</li>
                    <li>in connection with any legal proceedings or prospective legal proceedings;
                    </li>
                    <li>in order to establish, exercise or defend our legal rights (including
                        providing information to others for the purposes of fraud prevention and
                        reducing credit risk); and Except as provided in this privacy policy, we
                        will not provide your information to third parties.</li>
                </ol>
                <li>Your rights:<b class='font-bold' r>
                    Under the Data Protection Act 2018 (including the General Data Protection
                    Regulations (GDPR) you may request details of personal information that we hold
                    about you. There will be no charge for the first request, but a small admin fee
                    may be applied for further requests. If you want to make a request, please write
                    to us by email to&nbsp;<a target='_blank' rel="noreferrer" class='text-[#846bb9] hover:text-[#6bb2b9]' href="enquiries@kenworthychiropractic.com">enquiries@kenworthychiropractic.com</a>
                </li>
            </ol>
            <p class='mb-[20px]'>If you have any questions about this privacy policy or our treatment of your personal
                data, please write to us by email to&nbsp;<a target='_blank' rel="noreferrer" class='text-[#846bb9] hover:text-[#6bb2b9]' href="enquiries@kenworthychiropractic.com">enquiries@kenworthychiropractic.com</a>.
            </p> 
        `
    },
    {
        title: 'Cookie Policy',
        description: `
    <b class='font-bold' >What Are Cookies</b>
    <p class='mb-[20px]'>As is common practice with all professional websites this site uses cookies, which
        are files
        that are stored on your computer to improve your experience whilst visiting the
        Kenworthy
        Chiropractic website.</p> 
    <b class='font-bold' >The Cookies We Use</b>
    <p class='mb-[20px]'>The following section details which cookies are used throughout the website.</p> 
    <ul class='mb-[20px]'>

        <li>This site uses Google Analytics which is one of the most widespread and trusted
            analytics solution on the web for helping us to understand how you use the site
            and
            ways that we can improve your experience. These cookies may track things such as
            how long you spend on the site and the pages that you visit so we can continue
            to
            produce engaging content. No personal information is stored.</li>
    </ul>

    <p class='mb-[20px]'>For more information on Google Analytics cookies, see the official Google Analytics
        page.</p> 

    <b class='font-bold' > Disabling Cookies</b>
    <p class='mb-[20px]'>You can prevent the setting of cookies by adjusting the settings on your browser. Be
        aware
        that disabling cookies may affect the functionality of this and many other websites
        that you
        visit.</p> 

    <p class='mb-[20px]'>To learn how to disable cookies, visit <a target='_blank' rel="noreferrer" class='text-[#846bb9] hover:text-[#6bb2b9]' target="_blank" href="https://cookies.insites.com/disable-cookies/">cookies.insites.com/disable-cookies/</a>
    </p> 

    <p class='mb-[20px]'>If you have any questions about this cookie policy please write to us by email
        to&nbsp;<a target='_blank' rel="noreferrer" class='text-[#846bb9] hover:text-[#6bb2b9]' href="mailto:enquiries@kenworthychiropractic.com">enquiries@kenworthychiropractic.com</a>.
    </p> `
    },
    {
        title: 'Letter and Admin Charges',
        description: `
    <table class='w-full text-lg'>
        <thead>
        <tr class="border-b bg-white my-2">
                <th class='text-start font-semibold'>Letter</th>
                <th class='text-start font-semibold'>Charges</th>
            </tr>
        </thead>
        <tbody>
        <tr class="border-b bg-neutral-100 my-2">
        <td>Insurance Report</td>
                <td>£50</td>
            </tr>
            <tr class="border-b bg-white my-2">
            <td>Doctor Referral Letter Initiated by the Chiropractor</td>
                <td>Free</td>
            </tr>
            <tr class="border-b bg-neutral-100 my-2">
            <td>Doctor Referral Letter Initiated by Patient</td>
                <td>£25</td>
            </tr>
            <tr class="border-b bg-white my-2">
            <td>Reissue/Reprint of Letter/Report</td>
                <td>£15</td>
            </tr>
            <tr class="border-b bg-neutral-100 my-2">
            <td>Letter For Employer From the Chiropractor</td>
                <td>£25</td>
            </tr>
            <tr class="border-b bg-white my-2">
            <td>Other Admin Requests</td>
                <td>£15</td>
            </tr>
            <tr class="border-b bg-neutral-100 my-2">
            <td>Subject Access Request (GDPR 2019 (1st Request))</td>
                <td>Free</td>
            </tr>
            <tr class="border-b bg-white my-2">
            <td>Printed Invoice</td>
                <td>Free</td>
            </tr>
        </tbody>
    </table>`
    },
    {
        title: 'Useful Links:',
        description: `
        <ul>
        <li class="my-2">
          <p class="font-semibold text-gray-700">
            McTimoney Chiropractic Association
          </p>
          <a
            class="text-secondary hover:text-primary transition-all ease-in duration-200 hover:ml-1 ml-0"
            href="http://mctimoney-chiropractic.org"
            target="_blank"
            rel="noreferrer"
          >
            www.mctimoney-chiropractic.org
          </a>
        </li>

        <li class="my-2">
          <p class="font-semibold text-gray-700">
            General Chiropractic Council
          </p>
          <a
            class="text-secondary hover:text-primary transition-all ease-in duration-200 hover:ml-1 ml-0"
            href="http://gcc-uk.ork"
            target="_blank"
            rel="noreferrer"
          >
            www.gcc-uk.org
          </a>
        </li>

        <li class="my-2">
          <p class="font-semibold text-gray-700">
            Royal College of Chiropractors
          </p>
          <a
            class="text-secondary hover:text-primary transition-all ease-in duration-200 hover:ml-1 ml-0"
            href="http://rcc-uk.org"
            target="_blank"
            rel="noreferrer"
          >
            www.rcc-uk.org
          </a>
        </li>

        <li class="my-2">
          <p class="font-semibold text-gray-700">NICE</p>
          <a
            class="text-secondary hover:text-primary transition-all ease-in duration-200 hover:ml-1 ml-0"
            href="http://nice.org.uk"
            target="_blank"
            rel="noreferrer"
          >
            www.nice.org.uk
          </a>
        </li>
      </ul>
    ` },
    {
        title: 'Licencing',
        description: `
    <p class='mb-[20px]'/>This website has been built on the React framework, incorperating the following libraries and packages:</p>
    <ul class='mb-[20px]'/>
        <li>React - MIT. Licence</li>
        <li>React-Icons - MIT. Licence</li>
        <li>Hamburger-react - MIT. Licence Luuk de Vlieger</li>
        <li>React-reveal - MIT. Licence 2018 Roman Nosov</li>
        <li>Awesome-button - MIT. Licence 2019 Rafael Caferati</li>
        <li>Slick-carousel - MIT License 2017</li>
        <li>TailwindCss - MIT License</li>
        <li>ABeeZee - Open Font Licence</li>

    </ul>`
    },

]